import Cookies from 'js-cookie';
import { io } from 'socket.io-client';
import { useOrganization } from './useOrganization';

export interface WebSocketAuth {
    page?: number;
}

export const useWebSocket = (auth: WebSocketAuth) => {
    const websocketUrl = process.env.VUE_APP_API_BASE_URL;
    const { organization } = useOrganization()

    console.log('Conectando ao WebSocket em:', websocketUrl);

    const socket = io(websocketUrl, {
        auth: {
            token: Cookies.get("token") ?? process.env.VUE_APP_AUTH_TOKEN,
            organizationId: organization?.id,
            ...auth
        }
    });

    return socket;
};
